import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a9450b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-items mb-20" }
const _hoisted_2 = { class: "ap-input-group" }
const _hoisted_3 = { class: "ap-input-label" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "ap-input-group" }
const _hoisted_6 = { class: "ap-input-label" }
const _hoisted_7 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ap_button = _resolveComponent("ap-button")!
  const _component_ApModalBase = _resolveComponent("ApModalBase")!

  return (_openBlock(), _createBlock(_component_ApModalBase, {
    name: _ctx.name,
    title: _ctx.isNew ? _ctx.$t('modal.email-profile.title-new') : _ctx.$t('modal.sms-profile.title-edit'),
    titleIcon: 'ap-icon-person',
    cancelText: _ctx.$t('modal.button.cancel'),
    showClose: true,
    width: 625,
    height: null,
    onOpen: _ctx.beforeOpen
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_ap_button, {
        "btn-class": "btn-primary",
        onClick: _ctx.saveProfile
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.isNew ? _ctx.$t('modal.email-profile.actions.create') : _ctx.$t('modal.email-profile.actions.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('modal.email-profile.fields.name')), 1),
          _withDirectives(_createElementVNode("input", {
            style: {"width":"100%"},
            class: "ap-input",
            placeholder: _ctx.$t('modal.email-profile.fields.name-placeholder'),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profile.Name) = $event))
          }, null, 8, _hoisted_4), [
            [_vModelText, _ctx.profile.Name]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('modal.email-profile.fields.from-name')), 1),
          _withDirectives(_createElementVNode("input", {
            style: {"width":"100%"},
            class: "ap-input",
            placeholder: _ctx.$t('modal.email-profile.fields.from-name-placeholder'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profile.From) = $event))
          }, null, 8, _hoisted_7), [
            [_vModelText, _ctx.profile.From]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["name", "title", "cancelText", "onOpen"]))
}